import { render, staticRenderFns } from "./DialogRealTime.vue?vue&type=template&id=90872974&scoped=true"
import script from "./DialogRealTime.vue?vue&type=script&lang=js"
export * from "./DialogRealTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90872974",
  null
  
)

export default component.exports